export function handleEnter (options, prefixes, element) {
    if (options.shadow) {
        element.style[prefixes.boxShadow] = '0px 2.8px 2.2px rgba(0, 0, 0, 0.042), 0px 6.7px 5.3px rgba(0, 0, 0, 0.061), 0px 12.5px 10px rgba(0, 0, 0, 0.075), 0px 22.3px 17.9px rgba(0, 0, 0, 0.089), 0px 41.8px 33.4px rgba(0, 0, 0, 0.108), 0px 100px 80px rgba(0, 0, 0, 0.15)';
    }
}